import { ClbIcon } from "@celebration/react";
import styles from "./StepCard.module.scss";

export interface StepCardProps {
  message: string;
  eventType: string;
  isProcessed?: boolean;
  isNext?: boolean;
  showDivider?: boolean;
  children?: React.ReactNode;
}

const getStatusIcon = (eventType: string, isProcessed: boolean, isNext: boolean) => {
  // Se foi processado, mostra o ícone do status
  if (isProcessed) {
    switch (eventType?.toUpperCase()) {
      case "ERROR":
        return <ClbIcon icon="cancel" size="md" style={{ color: "#D32F2F" }} />;
      case "IN_PROGRESS":
      case "PROCESSING":
        return <ClbIcon icon="loader" size="md" style={{ color: "#2B83F7" }} />;
      case "SUCCESS":
      case "FINISH":
      default:
        return <ClbIcon icon="checkbox-circle" size="md" style={{ color: "#2E7D32" }} />;
    }
  }

  // Se é a próxima etapa, mostra loading azul
  if (isNext) {
    return <ClbIcon icon="loader" size="md" style={{ color: "#2B83F7" }} />;
  }

  // Etapas futuras: sem ícone (apenas espaço reservado)
  return <span style={{ width: 24, height: 24 }} />;
};

const StepCard: React.FC<StepCardProps> = ({ 
  message, 
  eventType, 
  isProcessed = true,
  isNext = false,
  showDivider = false,
  children,
}) => {
  // Fundo branco se processado OU se é a próxima etapa (loading)
  const isActive = isProcessed || isNext;
  
  const cardClasses = [
    styles["step-card"],
    !isActive && styles["step-card--disabled"],
  ].filter(Boolean).join(" ");

  return (
    <>
      <div className={cardClasses} data-testid="step-card" data-disabled={!isActive}>
        <div className={styles["step-card__icon"]}>
          {getStatusIcon(eventType, isProcessed, isNext)}
        </div>
        <div className={styles["step-card__content"]}>
          <span className={styles["step-card__content-title"]}>
            {message}
          </span>
          {children}
        </div>
      </div>
      {showDivider && <div className={styles["step-card__divider"]} data-testid="step-card-divider" />}
    </>
  );
};

export default StepCard;
